//Get Notifications
export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_RECEIVE = "GET_NOTIFICATIONS_RECEIVE";
//Seen Notifications
export const SEEN_NOTIFICATIONS_REQUEST = "SEEN_NOTIFICATIONS_REQUEST";
export const SEEN_NOTIFICATIONS_RECEIVE = "SEEN_NOTIFICATIONS_RECEIVE";
